module.exports = __webpack_public_path__ + "img/logo.ef0b1fc9.png";